import ScrollContainer from "@memorang/ui/components/ScrollContainer";

import { isWeb } from "@memorang/helpers/platform";
import type { Passage, Slide } from "@memorang/types";
import Box from "@memorang/ui/components/Box";
import CustomTabs from "@memorang/ui/components/CustomTabs";
import InfoAlert from "@memorang/ui/components/InfoAlert";
import type { SlideData } from "@memorang/ui/components/SlideShow";
import { ScrollView } from "react-native";
import { Text } from "react-native-paper";
import composeSessionMd from "../helpers/compose-session-md";
import useSessionStore from "../hooks/useSessionStore";
import ItemStem from "./ItemStem";
import SlideShowRenderer from "./SlideShowRenderer";

type Props = {
	parentTitle: string;
	slideshowData: SlideData[];
	parentInstruction: string;
	parentIndex: number;
	padding?: number;
	slides: Slide[];
	itemId?: number;
};

const ReadView = ({
	passage,
	parentTitle,
}: {
	passage: Passage;
	parentTitle: string;
}) => {
	const parentStem = composeSessionMd({
		content: passage,
	});
	return (
		<ScrollContainer
			contentContainerStyle={{
				paddingBottom: 100,
				flexGrow: 1,
				paddingTop: isWeb ? 16 : 0,
			}}
		>
			<Box gap={16}>
				<Text variant="titleLarge">{parentTitle}</Text>
				<ItemStem text={parentStem} fontSize={14} />
			</Box>
		</ScrollContainer>
	);
};
const StimulusTabContent = ({
	parentTitle,
	slideshowData,
	parentInstruction,
	parentIndex,
	padding = 16,
	slides,
	itemId,
}: Props) => {
	const completedTasks = useSessionStore((state) => state.completedTasks);
	const updateCompletedTasks = useSessionStore(
		(state) => state.updateCompletedTasks,
	);

	const hasCompleted = itemId ? completedTasks?.[itemId] : false;
	if (!slideshowData.length) {
		return <ReadView passage={slides[0].passage!} parentTitle={parentTitle} />;
	}
	const tabs = slides.map((slide, index) => {
		return {
			label: slide.title!,
			badge: index && !hasCompleted ? true : undefined,
			// icon: index === 0 ? "book-open-page-variant-outline" : "headphones",
			content: slide.passage ? (
				<ReadView passage={slide.passage} parentTitle={parentTitle} />
			) : (
				<ScrollView
					contentContainerStyle={{
						flexGrow: 1,
						paddingTop: isWeb ? 16 : 0,
						paddingBottom: 100,
						gap: 16,
					}}
				>
					<Text variant="titleLarge">{parentTitle}</Text>
					<SlideShowRenderer slideshowData={slideshowData} itemId={itemId} />
				</ScrollView>
			),
		};
	});

	return (
		<Box padding={padding} gap={16} flex={1}>
			{parentInstruction && parentIndex === 1 && (
				<InfoAlert text={parentInstruction} />
			)}
			<CustomTabs
				tabs={tabs}
				backgroundColor="transparent"
				onChangeIndex={(index) => {
					if (itemId && !completedTasks?.[itemId] && index) {
						updateCompletedTasks(itemId, true);
					}
				}}
			/>
		</Box>
	);
};

export default StimulusTabContent;
